$.fn.AnimateWaves = function(options) {
  let self = this
  let animateWaves = false;
  let stop_animation_timer;
  self.scrollEvents = $(window).ScrollEvents();

  self.calculatePosition = function() {
    if (!animateWaves) {
      animateWaves = true
      self.css('--animation-play-state', 'runnning')
      self.removeClass('page-section--wave-stopped')
    }

    clearTimeout(stop_animation_timer);
    stop_animation_timer = setTimeout(stopAnimation, 300)
  }

  function stopAnimation() {
    self.css('--animation-play-state', 'paused')
    self.addClass('page-section--wave-stopped')
    animateWaves = false
  }

  return function() {
    self.scrollEvents.add(self.calculatePosition);
    return self
  }()
}
